import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import {
  IMark,
  MapMarkImportResult,
  MarkCreationPayload,
} from "../types/index";

export const markApi = createApi({
  reducerPath: "markApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getMarks: builder.query<{ marks: IMark[]; count: number}, FilterParams | any>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
          .join('&');

        return `/marks/dashboard?${queryString}`;
      },
    }),
    getMarkById: builder.query<IMark, string>({
      query: (markId) => `/marks/${markId}`,
    }),
    createMark: builder.mutation<void, MarkCreationPayload>({
      query: (body) => ({
        url: "/marks",
        method: "POST",
        body,
      }),
    }),
    updateMark: builder.mutation<void, {id: string; body: MarkCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/marks/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateMarkConfiguration: builder.mutation<void, {
      id: string;
      body: {
        bestSeller?: boolean;
        activeInHome?: boolean;
      };
    }>({
      query: ({ id, body }) => ({
        url: `/marks/${id}/config`,
        method: "PATCH",
        body,
      }),
    }),
    deleteMark: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/marks/${id}`,
        method: "DELETE",
      }),
    }),
    deleteAllMarks: builder.mutation<{ message: string; deleted: number }, void>({
      query: () => ({
        url: "/marks",
        method: "DELETE",
      }),
    }),
    importPreview: builder.mutation<{ total: number; preview: any[] }, File>({
      query: (file) => {
        const formData = new FormData();

        formData.append("file", file);

        return {
          url: "/marks/import/preview",
          method: "POST",
          body: formData,
        };
      },
    }),
    importConfirm: builder.mutation<MapMarkImportResult, { marks: any[] }>({
      query: (body) => ({
        url: "/marks/import/confirm",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetMarksQuery,
  useLazyGetMarksQuery,
  useDeleteMarkMutation,
  useDeleteAllMarksMutation,
  useImportPreviewMutation,
  useImportConfirmMutation,
  useCreateMarkMutation,
  useUpdateMarkMutation,
  useUpdateMarkConfigurationMutation,
  useLazyGetMarkByIdQuery,
} = markApi;
